(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const desktopChatMedia = window.matchMedia('(min-width: 1150px)');
  let pendingChatOpen = false;

  function syncCommslayerChat() {
    const chat = window.$chatwoot;
    if (!chat?.hasLoaded) return;

    const hasMenuTrigger = Boolean(document.querySelector('[data-commslayer-open]'));
    chat.toggleBubbleVisibility(desktopChatMedia.matches || !hasMenuTrigger ? 'show' : 'hide');

    if (pendingChatOpen && hasMenuTrigger) {
      pendingChatOpen = false;
      chat.toggle('open');
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-commslayer-open]');
    if (!link) return;

    event.preventDefault();
    const drawer = link.closest('navigation-drawer');
    if (drawer?.open) drawer.hide();
    pendingChatOpen = true;
    syncCommslayerChat();
  });

  window.addEventListener('chatwoot:ready', syncCommslayerChat);
  desktopChatMedia.addEventListener('change', syncCommslayerChat);
  document.addEventListener('shopify:section:load', syncCommslayerChat);
  syncCommslayerChat();

  } catch(e) { console.error(e); }
})();
})();
